module.exports = __webpack_public_path__ + "img/line_pattern.9ab6ba77.png";